export default "__VITE_ASSET__DnXsxuxK__"